import { Translation } from 'locale'
import React from 'react'
import { GridSettingToggleSwitch } from 'view/components/datagrid/toolbar/GridSettingToggleSwitch'

export const AxeGridToolbarSwitches = [
  () => <GridSettingToggleSwitch label={Translation.TC_SHOW_CANCELLED_AXES} setting="showCancelledAxes" />
]
